export default {
  namespaced: true,
  inventory: {
    title: "Inventory",
    new: "New inventory",
    edit: "Edit inventory",
    error_title: "There are errors in the file:",
    fields: {
      region: "Region",
      municipality: "Municipality",
      rems: "REMS",
      sirh: "SIRH",
      unit: "Unit",
      unit_name: "Unit name",
      unit_type: "Unit type",
      equipment_type: "Equipment type",
      brand: "Brand",
      model: "Model",
      status: "Status",
      installation_date: "Installation date",
      depreciation_start_date: "Depreciation start date",
      useful_life_months: "Useful life (months)",
      remaining_life_months: "Remaining life (months)",
      project: "Project",
      project_id: "Project ID",
      project_name: "Project name",
      division: "Division",
      municipality: "Municipality",
      unit_category: "Unit category",
      unit_name: "Unit name",
      equipment_type: "Equipment type",
      serial_number: "Serial number",
      fixed_asset_number: "Fixed asset number",
      equipment_cost: "Equipment cost",
      accumulated_depreciation: "Accumulated depreciation",
      project: "Project",
      name: "Name",
      updated_at: "Updated",
      created_at: "Created",
    },
    actions: {
      cancel: "Cancel",
      save: "Save",
    },
    status: {
      installed: "Installed",
      new_custody: "New custody",
      paused: "Paused",
    },
    catalogs: {
      brands: "Brand catalog",
      projects: "Project catalog",
      equipmentTypes: "Equipment type catalog",
    },
  },
};
